<template>
<div style="margin-top:-6px !important">
  <!-- <v-row> -->
    <!-- <v-col cols="12">
      <h1>計畫項目時程管理</h1>
    </v-col> -->
  <!-- </v-row> -->
  <VCard>
    <VCardText>
      <v-row class="">
        <v-col cols="12" sm="6" md="4">
          <v-select label="計畫項目"
            item-title="1"
            item-value="0"
            v-model="viewParams.projectId"
            :items="viewParams.projectSelect" 
            ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="8" class="d-flex justify-end">
          <v-btn prepend-icon="tabler-download" color="primary" class="ml-2" @click="exportData" :loading="viewParams.dwnLoading" :disabled="!tableParams.data.length">匯出</v-btn>
        </v-col>
      </v-row>
    </VCardText>
  </VCard>
  <VCard class="mt-2">
    <v-data-table
      :headers="tableParams.headers"
      :items="tableParams.data"
      items-per-page="10"
      class="elevation-1"
      fixed-header 
      :loading="viewParams.loading"
      no-data-text="尚無資料"
      >
    </v-data-table>
  </VCard>
  </div>
</template>

<script  setup lang="ts">

definePage({
  meta: {
      action: 'manage', //固定為 manage
      subject: 'PROJECTSCHEDULE', //系統代碼(系統授權設定中的系統代碼)
  },
});

const viewParams = reactive({
  projectSelect: [],
  projectId: '',
  dwnLoading: false,
  loading: false
});

const tableParams = reactive({
  headers: [], 
  data: []
});    

onMounted(() => {
  getProjectSelect();
});

watch(() => viewParams.projectId , async (newValue) => {
  search();
});

const search = async () => {
  const formData = new FormData();
  formData.append('projectId', viewParams.projectId);
  viewParams.loading = true;
  const apiUrl='/tca/projectschedule/search'
  await $api(apiUrl, {
    method: 'POST',
    body: formData
  }).then((resp) => {
    if (resp.statusCode == 200) {
        // 處理 headers
      tableParams.headers.length = 0;
      tableParams.headers.push({ title: '協會', key: 'DEPNAME',width: "150px" })
      tableParams.headers.push({
        title: '選手培訓參賽實施計畫(含培訓教練選手遴選辦法)', align: 'center', children: [
          { title: '已送訓輔', key: 'project_sendedDate',width: "150px" },
          { title: '中心備查', key: 'project_reviewDate',width: "150px" },
          { title: '已公告', key: 'project_publishDate',width: "150px" },
        ],
      });
      tableParams.headers.push({
        title: '代表隊教練選手遴選辦法', align: 'center', children: [
          { title: '已送訓輔', key: 'guide_sendedDate',width: "150px" },
          { title: '中心備查', key: 'guide_reviewDate',width: "150px" },
          { title: '已公告', key: 'guide_publishDate',width: "150px" },
        ],
      });
      resp.data.tbtca11Vos.forEach(function(tbtca11Vo) {
        if(tbtca11Vo.stage !== 'end') {
          tableParams.headers.push(
            {
              title: '培訓名單('+stageToText(tbtca11Vo.stage)+')_'+toText(convertToROCDate(tbtca11Vo.startDate,'-'))+'-'+toText(convertToROCDate(tbtca11Vo.endDate,'-')) , align: 'center', children: [
                { title: '已送訓輔', key: 'team_sendedDate_'+tbtca11Vo.stage,width: "150px" },
                { title: '已調訓', key: 'team_trainingDate_'+tbtca11Vo.stage ,width: "150px"}
              ],
            }
          );
        } 
      });
      tableParams.headers.push({
        title: '建議參賽名單', align: 'center', children: [
          { title: '已送訓輔', key: 'selection_sendedDate',width: "150px" },
          { title: '中心備查', key: 'selection_reviewDate' ,width: "150px"},
        ],
      });

      tableParams.data = resp.data.tableData;
      const regex = /^\d{8}$/;
      // 處理西元轉民國
      tableParams.data = tableParams.data.map(function(item){
          Object.entries(item).forEach(([key, value]) => {
            if(regex.test(value)) {
              item[key] = toText(convertToROCDate(value,'-'));
            }
          })
          return item;
      })

      popSwal('success','查詢完成');
    } else  {
      popSwal('error','送出失敗,錯誤訊息'+resp.data);
    }
    viewParams.loading = false;
  })
}

const exportData = async () => {
  viewParams.dwnLoading = true;
  const apiUrl='/tca/projectschedule/export';
  await $api(apiUrl, {
    method: 'POST',
    body: tableParams
  }).then((resp) => {
    viewParams.dwnLoading = false;
    if (resp.statusCode == 400) {
      popSwal('error','匯出失敗,錯誤訊息：'+resp.data);
      return ;
    }
    var fileURL = window.URL.createObjectURL(new Blob([resp]));
    var fileLink = document.createElement('a');
    fileLink.href = fileURL;
    fileLink.setAttribute('download', '計畫項目時程管理匯出_'+new Date().getTime()+'.xlsx');
    document.body.appendChild(fileLink);
    fileLink.click();

  })
}

const getProjectSelect = async () => {
  const apiUrl='/tca/trainingteam/get/project/select'
  await $api(apiUrl, {
    method: 'GET'
  }).then((resp) => {
    Object.assign(viewParams.projectSelect, resp.data); 
  })
};

const popSwal = (icon,title) => {
  $swal({
    position: 'top-end',
    icon: icon,
    title: title,
    showConfirmButton: false,
    timer: 3000,
    customClass: {
      confirmButton: 'btn btn-primary',
    },
    buttonsStyling: false,
  });
}

const stageToText = (stage) => {
  // 轉換 第一階段：1，第二階段第一期：2.1 ，以此類推
  let dispStage = '';
  const regex = /(\d+)\.?(\d?)/;
  const matches = stage.match(regex);
  if(matches) {
    let cNum = numberToChinese(matches[1]);
    dispStage = '第' + cNum + '階段';
    if(matches[2]) {
      cNum = numberToChinese(matches[2]);
      dispStage = dispStage + '第' + cNum +'期';
    }
  } else {
    dispStage = '建議參賽名單';
  }
  return dispStage;
}

function numberToChinese(num) {
  const chineseDigits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  let chineseNum = '';
  // 处理整数部分
  const integerPart = Math.floor(num);
  if (integerPart > 0) {
    const digits = integerPart.toString().split('').reverse();
    for (let i = 0; i < digits.length; i++) {
      if (digits[i] !== '0') {
        chineseNum = chineseDigits[digits[i]] +  chineseNum;
      } else {
        // 处理连续的零
        if (chineseNum.length > 0 && chineseNum[chineseNum.length - 1] !== '零') {
          chineseNum += '零';
        }
      }
    }
  }
  return chineseNum;
}

</script>

<style scoped>
.ml-2 {
  margin-left: 8px;
}
</style>
